
import React, { useEffect, useState } from "react";
import API_URL from "../../services/api";
import "./Announcement.css";

const Announcement = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  // ==============================
  // Fetch Announcements
  // ==============================
  const fetchAnnouncements = async () => {
    try {
      setLoading(true);

      const res = await fetch(`${API_URL}/api/announcements`);

      if (!res.ok) {
        throw new Error("Failed to fetch announcements");
      }

      const data = await res.json();

      const activeAnnouncements = data
        .filter((item) => item.status === "Active")
        .sort(
          (a, b) =>
            new Date(b.announcement_date) -
            new Date(a.announcement_date)
        );

      setAnnouncements(activeAnnouncements);
    } catch (err) {
      console.error("Announcement Error:", err);
      setAnnouncements([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  // ==============================
  // Search
  // ==============================
  const filteredAnnouncements = announcements.filter((item) => {
    const title = item.title?.toLowerCase() || "";
    const description = item.description?.toLowerCase() || "";
    const searchText = search.toLowerCase();

    return (
      title.includes(searchText) ||
      description.includes(searchText)
    );
  });

  return (
    <div className="announcement-page">

      {/* Header */}
      <div className="announcement-header">
        <h1>Library Announcements</h1>

        <p>
          Stay updated with the latest news, events, and
          important information from Ghalib Library.
        </p>
      </div>

      {/* Search */}
      <div className="announcement-search-container">
        <input
          type="text"
          placeholder="Search announcements..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="announcement-search"
        />
      </div>

      {/* Loading */}
      {loading && (
        <div className="announcement-message">
          <h2>Loading announcements...</h2>
        </div>
      )}

      {/* No Results */}
      {!loading && filteredAnnouncements.length === 0 && (
        <div className="announcement-empty">
          <div className="empty-icon">📢</div>

          <h2>No Announcements Available</h2>

          <p>
            There are currently no active announcements.
          </p>
        </div>
      )}

      {/* Announcements */}
      {!loading && filteredAnnouncements.length > 0 && (
        <div className="announcement-grid">

          {filteredAnnouncements.map((item) => (
            <div
              className="announcement-card"
              key={item.id}
            >

              {/* Top */}
              <div className="announcement-top">

                <h2 className="announcement-title">
                  {item.title}
                </h2>

                <span className="announcement-badge">
                  Active
                </span>

              </div>

              {/* Description */}
              <p className="announcement-description">
                {item.description}
              </p>

              {/* Bottom */}
              <div className="announcement-bottom">

                <span className="announcement-date">
                  📅{" "}
                  {item.announcement_date
                    ? new Date(
                        item.announcement_date
                      ).toLocaleDateString()
                    : "Date unavailable"}
                </span>

              </div>

            </div>
          ))}

        </div>
      )}

    </div>
  );
};

export default Announcement;
